import React, { useState, useEffect, useContext } from "react";
import Notification from "./Notification";
import { useTranslation } from "react-i18next";
import { GET } from "../../utils/fetchUtil";
import { MessageContext } from "../../common/message";

function NotificationPanel() {
  const [notifications, setNotifications] = useState([]);
  const [stats, setStats] = useState({
    read: 0,
    unread: 0,
  });
  const { t } = useTranslation();

  const message = useContext(MessageContext);

  const countByStatus = (notifications, status) =>
    notifications.filter((notification) => notification.isNew === status).length;

  useEffect(() => {
    GET(
      "/notifications",
      (notifications) => {
        setNotifications(notifications);

        setStats({
          read: countByStatus(notifications, false),
          unread: countByStatus(notifications, true),
        });
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, []);

  return (
    <>
      <div className="content">
        <div className="subtitle">{`${t("notifications.unread")} (${stats.unread})`}</div>
        {notifications
          .filter((notification) => notification.isNew === true)
          .map((notification) => (
            <Notification
              key={`notification${notification.id}`}
              title={notification.title}
              subject={notification.subject}
              status={notification.status}
              date={notification.dateCreated}
              linkLabel={notification.linkLabel}
              linkValue={notification.linkValue}
              linkTab={notification.linkTab}
            />
          ))
          .reverse()}
      </div>
      <div className="content">
        <div className="subtitle">{`${t("notifications.read")} (${stats.read})`}</div>
        {notifications
          .filter((notification) => notification.isNew === false)
          .map((notification) => (
            <Notification
              key={`notification${notification.id}`}
              title={notification.title}
              subject={notification.subject}
              status={notification.status}
              date={notification.dateCreated}
              linkLabel={notification.linkLabel}
              linkValue={notification.linkValue}
              linkTab={notification.linkTab}
            />
          ))
          .reverse()}
      </div>
    </>
  );
}

export default NotificationPanel;
